
const EquipmentData = [
    {id: 1,
      title: 'Analog',
      list: ['Sontec MES-432 Mastering Equalizer','Neumann BSB-74 Acceleration Limiter','Neumann w495b Mastering EQ','Focusrite Blue 315MKI Mastering Equalizer','Manley Massive Passive Equalizer','Neve 32087 Mastering Equalizer','MeyerSound CP-10 Equalizer','Dangerous Music S&M','Complete Dangerous Music Mastering Console and Monitoring and Metering system',

      ],
    },
    {id: 2,
      title: 'Workstation',
      list: ['Sequoia','Samplitude','Wavelab','Studio One','Korg AudioGate','Nuendo',
    ]
    },
    {id: 3,
    title: 'Digital',
    list: ['Lavry DA-N5 & AD122-96 MKIII','RME ADI-2 Pro FS R Black Edition & ADI-2 DAC FS','Weiss AFI-1','Z-Sys','Mutec MC-1.2',
  ]
    },
    {id:4,
    title: 'Playback',
    list: ['HEDDphones',"PSB M4U-2's",'Sennheiser HD-600','Mastering Lab Phono Preamp','Technics SL-1200 MKII','Tascam CD-500B transport',
  ]
    },
    {id:5,
     title: 'Plugins',
    list: ['CubeTec AudioCube','MDW','Apogee','FabFilter','UAD','Waves','Izotope','Newfangled','Cradle','DMG etc...',
  ]
  },
  {id:6,
  title: 'Cables and Power',
list: ['Mogami','Belden','Acoustic Zen','LAT International','Shunyata Research','PS Audio','240V Equitech power supplies',
]}

  ]

  export default EquipmentData